import api from "@/services/api.service";
import readXlsxFile from 'read-excel-file'
import { required } from "vuelidate/lib/validators";
import XLSX from 'xlsx'

export default {
    name: 'add',
    components: {readXlsxFile},
    props: {},
    data() {
        return {
            caption: "Add Direct Mass Import",
            campaign_form: true,
            mapping_form: false,
            operators: [],
            showField: true,
            formField: {header_data: {}, xls_file: '',title : '',tags:[]},
            headers: [],
            head: [],
            map_headers: [],
            file: '',
            submitStatus: null,
            existing_tags: [] ,
            selectedHeaders : [],
            permission_add: false,
            superAdmin: false,
            isread: 0          
        }
    },
    computed: {},
    validations: {
        formField: {
          title: {
            required
        },        
        tags: {
            required
        }
    }
},
async created() {
    let response = await api.post("users/user-permissions");
        const permissions = [];
        if (response.status == "success") {
          response.data[0].permission.forEach( function(element) {                
              permissions.push(element.action)
          }.bind(this));
            if(permissions.includes("add_direct_import_contact") == true){                
                this.getTags();   
                this.permission_add = permissions.includes("add_direct_import_contact");
            }else if(response.data[0].role == 'super_admin'){
                this.getTags();   
                this.superAdmin = true;
            }else if(permissions.includes("list_direct_import_contact") == true || permissions.includes("add_direct_import_contact") == true){
                this.makeToast("Permission denied","Alert","warning",6000);
                this.$router.push({name: 'Direct Mass Import List'});
            }else{
                this.makeToast("Permission denied","Alert","warning",6000);
                this.$router.push({name: 'Admin Dashboard'});
            }
        }  
},
mounted() {

},
methods: {
    makeToast(message = '', title = 'Alert', variant = 'warning', time = '3000') {
        this.toastCount++
        this.$root.$bvToast.toast(message, {
            title: title,
            variant: variant,
            autoHideDelay: time
        })
    },
    async getTags() {
      let response = await api.post("tags/list");
      if (!response)
        this.makeToast(
          "Something went to wrong please try again",
          "Alert",
          "danger",
          6000
          );
    if (response.status == "success") {
        response.data.forEach(
          function(e) {
            this.existing_tags.push({ key: e.tags.substring(0, 100), value: e.tags.substring(0, 100) });
        }.bind(this)
        );
    }
},
headerSelect(e,index) {
      this.selectedHeaders[index] = e;      
      this.map_headers.forEach( function(header) {
        header.disabled = false;
        this.selectedHeaders.forEach(function(element) {   
          if(header.value == element)
            header.disabled = true;
        });
      }.bind(this));
    },
    resetSelect(e){
        var indexOf = this.selectedHeaders.indexOf(e);
        this.map_headers.forEach( function(header) {
            if(header.value == e)
            header.disabled = false;
            this.selectedHeaders[indexOf] = null;
        }.bind(this));
        this.head.forEach(function(element) {   
            if(element.value == e)
            element.value = "";
        });
    
},    
async showMappedForm() {
    if (!this.formField.title) {
        this.makeToast(`Plase enter title.`, 'Alert', 'danger')
        return;
    }
    if (!this.formField.xls_file) {
        this.makeToast(`File is not uploaded.`, 'Alert', 'danger')
        return;
    }
    this.campaign_form = false;
    this.mapping_form = true;
    
    this.head = this.headers.map((h) => {
        return {name: h, 'value': ''}
    });
    let response = await api.post('admin/mapping_headers/list');
    if (!response)
        this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)


    if (response.status == 'success') {
        if (response.data != '') {
            for (var key in response.data.data) {
                this.map_headers.push({value: response.data.data[key].column_key, text: response.data.data[key].column,disabled: false})
            }
        } else {
            this.map_headers = [];
            this.makeToast(`No database headers found.`, 'Alert', 'danger')
        }
    } else
    this.makeToast(`No database headers found.`, 'Alert', 'danger')


},
async save() {
    if(this.selectedHeaders.length == 0){
        this.makeToast("Please select any header", "Alert", "danger");
        return;
    }
    if (this.head) {
        this.formField.map_headers = this.head;
        this.formField.campaign_id = this.$route.params.id;
        let response = await api.post('admin/direct-mass-import/add', this.formField);
        if (!response)
            this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)

        if (response.status == 'success') {            
            this.makeToast(response.message, 'Success', 'success')
            this.$router.push({'name': 'Direct Mass Import List'})
        } else {
            for (var error in response.errors)
                this.makeToast(response.errors[error], 'Alert', 'danger', 6000)
        }
    } else {
        this.makeToast(`Header not mapped ,please try again.`, 'Alert', 'danger')
        return false;
    }
},
onFileChanged(e) {
    e.stopPropagation();
    e.preventDefault();
    var file = e.target.files[0], results, data, fixedData, workbook, firstSheetName, worksheet;
    var reader = new FileReader();
    if (file.type !=="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
        this.makeToast("File must  be xlsx", "Alert", "danger");
        return;
       }
   this.isread = 1;
   let head1;
     reader.onload = function(e) {
           data = e.target.result;
           fixedData = fixdata(data);
           workbook = XLSX.read(btoa(fixedData), {type: 'base64'});
           firstSheetName = workbook.SheetNames[0];
           worksheet = workbook.Sheets[firstSheetName];
           head1 = get_header_row(worksheet);
           results = XLSX.utils.sheet_to_json(worksheet);
           results = btoa(results);

           //Header and Data Functions
           function get_header_row(sheet) {
               var headers_xls = [], range = XLSX.utils.decode_range(sheet['!ref']);
               var C, R = range.s.r; /* start in the first row */
               for(C = range.s.c; C <= range.e.c; ++C) { /* walk every column in the range */
                   var cell = sheet[XLSX.utils.encode_cell({c:C, r:R})] /* find the cell in the first row */
                   var hdr= null; // <-- replace with your desired default 
       
                       if(cell && cell.t) hdr = XLSX.utils.format_cell(cell);
                       if(hdr!=null){
                           headers_xls.push(hdr);
                       }                    
               }
               return headers_xls;
           }

           function fixdata(data) {
               var o = "", l = 0, w = 10240;
               for(; l<data.byteLength/w; ++l) o+=String.fromCharCode.apply(null,new Uint8Array(data.slice(l*w,l*w+w)));
               o+=String.fromCharCode.apply(null, new Uint8Array(data.slice(l*w)));
               return o;
           }
           //End
     }
     setTimeout(() => {
       this.headers = head1; 
       this.formField.xls_file = btoa(fixedData); 
       this.isread = 0;
   }, 3000);

   reader.readAsArrayBuffer(file);
},
}
}

